import { atom } from "recoil";

export const tableSchema: any = atom({
  key: "tableSchema",
  default: {},
});
export const activeTableNameState = atom<string | null>({
  key: "activeTableNameState",
  default: null,
});

export const agTableRowSize: any = atom({
  key: "agTableRowSize",
  default: 100,
});

export const agTableAirlineType: any = atom({
  key: "agTableAirlineType",
  default: "CLIENT",
});
export const agTableAirlineData: any = atom({
  key: "agTableAirlineData",
  default: {} as Record<string, any[]>, // Change to object to store data per tab/moduleId
});
export const tableLoadingState = atom({
  key: "tableLoadingState",
  default: true,
});

// Hotel-specific states to avoid conflicts with airline states
export const agTableHotelType: any = atom({
  key: "agTableHotelType",
  default: "CLIENT",
});

export const agTableHotelData: any = atom({
  key: "agTableHotelData",
  default: {} as Record<string, any[]>,
});

export const hotelActiveTabAtom = atom<string>({
  key: "hotelActiveTab",
  default: "",
});

export const hotelServerModeState = atom({
  key: "hotelServerModeState",
  default: false,
});

export const tableDynamicViews = atom({
  key: "tableDynamicViews",
  default: [
    {
      viewName: "All Data",
      viewConfig: "DEFAULT",
    },
  ],
});
